import { SettingContainer } from 'modules/Setting'
import React from 'react'

type Props = {}

const Settings = (props: Props) => {
  return (
    <SettingContainer />
  )
}

export default Settings